import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getFormBuilderToken } from '../../redux/features/generalSlice';
import { useSnackbar } from 'notistack';
import GlobalWrapper from '../../components/Wrapper/GlobalWrapper';
import { Alert, Box, Button, Paper, Typography } from '@mui/material';
import { Icon } from '@iconify/react/dist/iconify.js';
const formUrl = process.env.REACT_APP_FORM_URL;
const FormBuilder = ({scanner}) => {
  const [formToken, setFormToken] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { loading } = useSelector((store) => store?.general);

  useEffect(() => {
    retryAction();
  }, []);

  useEffect(() => {
    if (formToken) {
      if(scanner){
       window.open(`${formUrl}/scanner/?token=${formToken}`, '_blank');
      }else{
      window.open(`${formUrl}/?token=${formToken}`, '_blank');
    }
    }
  }, [formToken]);

  const retryAction = () => {
    dispatch(getFormBuilderToken()).then((res) => {
      if (res.payload.status === 'error') {
        enqueueSnackbar(res.payload.message, { variant: 'error' });
      } else if (res.payload.status === 'success' && res.payload.data) {
        setFormToken(res.payload.data);
      }
    });
  };

  return (
    <GlobalWrapper loading={loading} title={scanner ? "Food Scanner" : "Form Builder"}>
      <Box>
        {formToken && (
          <Paper elevation={6} sx={{ p: 3 }}>
            <Button
              endIcon={<Icon icon="ix:goto" width="25" height="25" style={{ color: '#41e20f' }} />}
              sx={{ boxShadow: 'none', px: 2 }}
              variant="outlined"
              color="success"
              onClick={retryAction}
            >
              Go To
            </Button>
          </Paper>
        )}

        {!formToken && (
          <Paper elevation={6} sx={{ p: 1, textAlign: 'center' }}>
            <Box sx={{ textAlign: 'center', fontSize: 20 }}>
              <Alert severity="error">Something went wrong, please try again later.</Alert>
            </Box>
            <Button
              variant="outlined"
              color="error"
              onClick={retryAction}
              sx={{
                my: 2,
                px: 4,
                borderRadius: '30px',
                fontWeight: 600,
                textTransform: 'none',
                boxShadow: 'none',
              }}
            >
              Retry
            </Button>
          </Paper>
        )}
      </Box>
    </GlobalWrapper>
  );
};

export default FormBuilder;
